module.exports = __webpack_public_path__ + "common/custa-logo-09776d21e66603aa8a32b488f9b6d5d3.svg";